export default __webpack_public_path__ + "static/media/norecordfound_new_01.ce7d9891.jpg";